<div class="refund-dialog-wrapper">
  <div class="dialog-header">
    <h2 class="dialog-title">Refund to Wallet</h2>
  </div>

  <div class="refund-dialog-content">
    <p class="message">
      {{ getMessage() }}
    </p>

    <div class="actions">
      <cac-button
        appearance="stroked"
        (onClick)="onNoRefund($event)"
      >
        No, Just Update
      </cac-button>

      <cac-button
        appearance="filled"
        (onClick)="onRefund($event)"
      >
        Yes, Refund to Wallet
      </cac-button>
    </div>
  </div>
</div>
